export default "__VITE_ASSET__BURmAGre__"